import { post } from "api";
import { queryClient } from "pages/Root";
import Services from "services/Services";

import { getUser } from "api/methods";

export async function updateUserIfAuthenticated(update: Record<string, unknown>): Promise<void> {
  try {
    const authHeaderToken = await Services.auth.loadToken();
    if (!authHeaderToken) return;
    await post("/user/update", update, authHeaderToken);
    await queryClient.invalidateQueries({ queryKey: getUser.key() });
  } catch (err) {
    console.error("[updateUserIfAuthenticated] update failed", err);
  }
}
